<template>
  <div>
    <a-form :form="form.fc" v-bind="formItemLayout">
     <a-form-item :label="$t('scope.text_41')">
        <a-row :gutter="20">
          <a-col :span="11">
            <base-select
              @change="handleWireChange"
              v-decorator="['wire', options.wire]"
              needParams
              isDefaultSelect
              :remote="true"
              :params="{ limit: 0 }"
              resource="wires"
              :remote-fn="q => ({ search: q })"
              :select-props="{ placeholder: $t('scope.text_42') }" />
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item :label="$t('scope.text_43')">
        <a-row :gutter="10" v-for="(item, index) in networkBaremetalList" :key="index">
          <a-col :span="2">
            <a-tag v-if="!index" color="blue">{{$t('scope.text_44')}}</a-tag>
          </a-col>
          <a-col :span="4">
            <a-form-item>
              <a-input disabled :value="item.name" :placeholder="$t('scope.text_45')" />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item>
              <a-input disabled :value="item.guest_ip_start" :placeholder="$t('scope.text_46')" />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item>
              <a-input disabled :value="item.guest_ip_end" :placeholder="$t('scope.text_47')" />
            </a-form-item>
          </a-col>
          <a-col :span="2">
            <a-form-item>
              <a-input-number disabled class="w-100" :value="item.guest_ip_mask" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item>
              <a-input disabled :value="item.guest_gateway" :placeholder="$t('scope.text_48')" />
            </a-form-item>
          </a-col>
        </a-row>
          <!-- 虚拟机 -->
        <a-row :gutter="10" v-for="(k, index) in form.fc.getFieldValue('keys')" :key="k">
          <a-col :span="2">
            <a-tag v-if="!index" color="blue">{{$t('scope.text_49')}}</a-tag>
          </a-col>
          <a-col :span="4">
            <a-form-item>
              <a-input  v-decorator="[`${k}.name`, options.name]" :placeholder="$t('scope.text_45')" />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item>
              <a-input v-decorator="[`${k}.guest_ip_start`, options.guest_ip_start]" :placeholder="$t('scope.text_46')" />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item>
              <a-input v-decorator="[`${k}.guest_ip_end`, options.guest_ip_end]" :placeholder="$t('scope.text_47')" />
            </a-form-item>
          </a-col>
          <a-col :span="2">
            <a-form-item>
              <a-select class="w-100" v-decorator="[`${k}.guest_ip_mask`, options.guest_ip_mask]">
                <a-select-option v-for="item in netMaskOptions" :key="item.value" :value="item.value">{{item.value}} </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item>
              <a-input v-decorator="[`${k}.guest_gateway`, options.guest_gateway]" :placeholder="$t('scope.text_48')" />
            </a-form-item>
          </a-col>
          <a-col :span="2" v-if="form.fc.getFieldValue('keys').length > 1">
            <a-button @click="handleRemove(k)" shape="circle" icon="minus" size="small" class="mt-2 ml-2" />
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item v-bind="offsetFormItemLayout" v-if="form.fc.getFieldValue('keys').length < 5">
        <a-row :gutter="10">
          <a-col :span="11">
            <a-form-item v-bind="offsetFormItemLayout">
              <a-button type="dashed" style="width: 50%" @click="handleAdd">
                <a-icon type="plus" />{{$t('scope.text_50')}}</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { getRequestT } from '@/utils/utils'

export default {
  name: 'GuideNetworkCreate',
  inject: ['formItemLayout', 'offsetFormItemLayout', 'tempData'],
  data () {
    return {
      loading: false,
      networkBaremetalList: [],
      form: {
        fc: this.$form.createForm(this),
      },
      netMaskOptions: [
        { label: '16', value: '16' },
        { label: '17', value: '17' },
        { label: '18', value: '18' },
        { label: '19', value: '19' },
        { label: '20', value: '20' },
        { label: '21', value: '21' },
        { label: '22', value: '22' },
        { label: '23', value: '23' },
        { label: '24', value: '24' },
        { label: '25', value: '25' },
        { label: '26', value: '26' },
        { label: '27', value: '27' },
        { label: '28', value: '28' },
        { label: '29', value: '29' },
        { label: '30', value: '30' },
      ],
      options: {
        wire: {
          rules: [
            { required: true, message: this.$t('scope.text_42') },
          ],
        },
        name: {
          initialValue: '',
          validateTrigger: ['change', 'blur'],
          validateFirst: true,
          rules: [
            { required: true, message: this.$t('scope.text_38') },
            { validator: this.$validate('resourceName') },
          ],
        },
        guest_ip_start: {
          validateTrigger: ['change', 'blur'],
          validateFirst: true,
          rules: [
            { required: true, message: this.$t('scope.text_51') },
            { validator: this.$validate('IPv4') },
          ],
        },
        guest_ip_end: {
          validateTrigger: ['change', 'blur'],
          validateFirst: true,
          rules: [
            { required: true, message: this.$t('scope.text_52') },
            { validator: this.$validate('IPv4') },
          ],
        },
        guest_ip_mask: {
          initialValue: '24',
        },
        guest_gateway: {
          validateTrigger: ['change', 'blur'],
          validateFirst: true,
          rules: [
            { required: true, message: this.$t('scope.text_53') },
            { validator: this.$validate('IPv4') },
            { validator: this.validateGateway },
          ],
        },
      },
    }
  },
  created () {
    this.form.fc.getFieldDecorator('keys', { initialValue: [new Date().valueOf()], preserve: true })
    this.manager = new this.$Manager('networks')
  },
  methods: {
    handleAdd () {
      const { fc } = this.form
      const keys = fc.getFieldValue('keys')
      const nextKeys = keys.concat(new Date().valueOf())
      fc.setFieldsValue({
        keys: nextKeys,
      })
    },
    handleRemove (k) {
      const { fc } = this.form
      const keys = fc.getFieldValue('keys')
      fc.setFieldsValue({
        keys: keys.filter(_ => _ !== k),
      })
    },
    handleWireChange (value) {
      this.fetchNetwork(value)
    },
    async fetchNetwork (wireId) {
      try {
        const { data } = await this.manager.list({
          params: {
            limit: 0,
            server_type: 'baremetal',
            wire_id: wireId,
          },
        })
        this.networkBaremetalList = (data.data || [])
      } catch (err) {
        throw err
      }
    },
    async doSubmit () {
      try {
        const { wire, ...values } = await this.form.fc.validateFields()
        delete values.keys
        const promises = []
        for (const k in values) {
          const params = {
            wire,
            vlan_id: '1',
            server_type: 'guest',
            ...values[k],
          }
          promises.push(new Promise((resolve, reject) => {
            this.manager.create({
              data: params,
              params: { $t: getRequestT() },
            }).then(({ data }) => {
              resolve(data)
            }).catch(err => {
              reject(err)
            })
          }))
        }
        await Promise.all(promises)
        return true
      } catch (err) {
        throw err
      }
    },
  },
}
</script>
